import type { Drug } from "../../types";

const storageNote =
  "Store at 2–8°C before first use. Protect from light. Do not freeze. After first use store at ≤30°C or refrigerated for up to 6 weeks.";

export const semaglutideDrug: Drug = {
  id: "semaglutide",
  name: "Semaglutide (Wegovy®)",
  drugClass: "GLP-1 receptor agonist",
  route: "subcutaneous",
  defaultFoodTiming: "May be administered at any time of day, with or without food",
  formulations: [
    { id: "semaglutide-0_25mg-pen", type: "prefilled_pen", strength: 0.25, strengthUnit: "mg", storageNote },
    { id: "semaglutide-0_5mg-pen",  type: "prefilled_pen", strength: 0.5,  strengthUnit: "mg", storageNote },
    { id: "semaglutide-1mg-pen",    type: "prefilled_pen", strength: 1.0,  strengthUnit: "mg", storageNote },
    { id: "semaglutide-1_7mg-pen",  type: "prefilled_pen", strength: 1.7,  strengthUnit: "mg", storageNote },
    { id: "semaglutide-2_4mg-pen",  type: "prefilled_pen", strength: 2.4,  strengthUnit: "mg", storageNote },
  ],
};
